import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Enquanto valida a sessão, não redireciona
  if (loading) {
    return <LoadingSpinner text="Verificando sessão..." />;
  }

  // Se não autenticado após verificar, envia ao /login e guarda rota de origem
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
